import React, { useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import oneDark  from "react-syntax-highlighter/dist/esm/styles/prism/one-dark";

export const JsonViewer = ({ data, label = "JSON" }: any) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-4 border rounded">
      <button
        onClick={() => setOpen(!open)}
        className="w-full text-left px-4 py-2 bg-gray-200 font-semibold"
      >
        {open ? "▼" : "▶"} {label}
      </button>

      {open && (
        <SyntaxHighlighter
          language="json"
          style={oneDark}
          customStyle={{ padding: "1rem", fontSize: "13px" }}
        >
          {JSON.stringify(data, null, 2)}
        </SyntaxHighlighter>
      )}
    </div>
  );
};
